module.exports = __webpack_public_path__ + "img/binding_mb_tab_01.987d8475.png";